import(/* webpackMode: "eager" */ "/codebuild/output/src2412997893/src/github.com/bitstone/offerz-nextjs/src/app/global-error.tsx");
